<template>
  <div class="modal fade" id="confirm-download-cvs-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <span v-html="message"></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal" @click="$emit('downloadCsv')">ダウンロード</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  mounted () {
    $('#confirm-download-cvs-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/components/ModalConfirmDownloadCsv.vue